export const CERTIFICATES_ROUTE: string = "/certificates";
